export default __webpack_public_path__ + "static/media/1990.e5d6ae09.png";